baseApp.service('ProgressBarService', [ function() {

    var progress;

}]);